import React from "react";
import ToDoList from "../Coder/ToDoList";
import AuditorHome from "./AuditorHome";

const Index = () => {
  return (
    <>
      <AuditorHome
        show={localStorage.getItem("attending") == null ? true : false}
      />
      <ToDoList />{" "}
    </>
  );
};

export default Index;
